import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-sky-100 bg-white/95 shadow-sm backdrop-blur" data-id="element-233" data-mp="232nfsn0fptzi">
      <div className="bg-primary px-3 py-1.5 text-center font-display text-[10px] font-bold tracking-wide text-white sm:text-xs md:text-sm" data-id="element-234" data-mp="1y4vej2dwgvin">
        🇦🇷 Sistema N°1 para el Cuidado de Espalda y Columna en Argentina
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-medium text-slate-500 md:flex" data-id="element-235" data-mp="2qry6tcrzga0g">
        <span className="flex items-center gap-1.5" data-id="element-236" data-mp="2h2oj09469di5">
          <ZapIcon className="h-3.5 w-3.5 text-accent" data-id="element-237" data-mp="2h1dcw2n97tnv" /> Acceso en 5 minutos
        </span>
        <span className="text-sky-300" data-id="element-238" data-mp="2c2jx23khvqkj">·</span>
        <span className="flex items-center gap-1.5" data-id="element-239" data-mp="2c1qyvqzlq9e0">
          <LockIcon className="h-3.5 w-3.5 text-accent" data-id="element-240" data-mp="39jr4hkhzyjei" /> Pago seguro
        </span>
        <span className="text-sky-300" data-id="element-241" data-mp="34rz82tc5tjgg">·</span>
        <span className="flex items-center gap-1.5" data-id="element-242" data-mp="34q645lsxldc5">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-243" data-mp="26aji67r6vsm" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}